import React from 'react';

const Burger = () => {
  return (
    <div className="burger">
      <div className="burger__line"></div>
      <div className="burger__line"></div>
      <div className="burger__line"></div>
    </div>
  );
};

export default Burger;
